"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPrimitiveGeoms = exports.geometries = void 0;
var __1 = require("../../..");
var constants_1 = require("../../../../specs/constants");
var create_selector_1 = require("../../../../state/create_selector");
var get_settings_specs_1 = require("../../../../state/selectors/get_settings_specs");
var utils_1 = require("../../../../state/utils");
var viewmodel_types_1 = require("../../layout/types/viewmodel_types");
var geoms_1 = require("../../layout/viewmodel/geoms");
var scenegraph_1 = require("./scenegraph");
var getParentDimensions = function (state) { return state.parentDimensions; };
exports.geometries = create_selector_1.createCustomCachedSelector([get_settings_specs_1.getSpecs, getParentDimensions], function (specs, parentDimensions) {
    var goalSpecs = utils_1.getSpecsFromStore(specs, __1.ChartType.Goal, constants_1.SpecType.Series);
    return goalSpecs.length === 1 ? scenegraph_1.render(goalSpecs[0], parentDimensions) : viewmodel_types_1.nullShapeViewModel();
});
exports.getPrimitiveGeoms = create_selector_1.createCustomCachedSelector([exports.geometries, getParentDimensions], function (shapeViewModel, _a) {
    var width = _a.width, height = _a.height;
    var config = shapeViewModel.config, chartCenter = shapeViewModel.chartCenter, bulletViewModel = shapeViewModel.bulletViewModel;
    return geoms_1.geoms(bulletViewModel, __assign(__assign({}, config), { width: width, height: height }), chartCenter);
});
//# sourceMappingURL=geometries.js.map